import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import Echo from 'laravel-echo';
import MoreBtn from "@/components/MoreBtn";
import VueExcelXlsx from "vue-excel-xlsx";
import RefreshBtn from "@/components/Refresh"
import VueApexCharts from 'vue-apexcharts'
import Trend from "vuetrend"
import AppLayout from '@/layouts/AppLayout'
import store from "@/store";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import Separate from "@/plugins/separate";
import translate from "@/plugins/Translate";
import VueCookies from 'vue-cookies'

// tailwind
import "./index.css"

Vue.use(VueCookies, { expires: '1d'})
library.add(faUserSecret)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('AppLayout', AppLayout)
import './registerServiceWorker';
import {cities} from './assets/data/cities'
Vue.mixin({
  data() {
    return {
      permissionsMixin: JSON.parse(localStorage.getItem('permissions'))
    }
  },
  methods : {
    getPermissionMixin(item){
      if (this.permissionsMixin?.length > 0)
        return this.permissionsMixin.includes(item)
      else
        return true
    },
    Seprate(number){
      return number ? Separate(number) : ''
    },
    getCities(){
      return cities
    },
    translate(item){
      return translate(item)
    },
    getPersianDate(date){
      return date ? getPersianDate(date) : ''
    },
    getPersianDateOnly(date){
      return date ? convertDateOnly(date) : ''
    },
    getMiladiDateOnly(date){
      return date ? ConvertDateFromTo(date) : ''
    },
    splitDot(v){
      return v ? v.split('.')[0] : ''
    },
    splitCama(v){
      return v ? +v.split(',').join('') : ''
    }
  }
});

import VueSidebarMenu from 'vue-sidebar-menu'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
import './registerServiceWorker'
import getPersianDate, {convertDateOnly} from "@/plugins/getPersianDate";
import {ConvertDateFromTo} from "@/plugins/convertDate";
import getPersianDateOnly from "@/plugins/getPersianDateOnly";

Vue.use(VueSidebarMenu)

Vue.use(Trend)
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
Vue.component('MoreBtn',MoreBtn)
Vue.component('RefreshBtn',RefreshBtn)
window.Pusher = require('pusher-js');


Vue.use(VueExcelXlsx);

window.Echo = new Echo({
  // broadcaster: 'pusher',
  // key: '5caf4802eb658f23f24c',
  // cluster: 'ap2',
  // forceTLS: true
  broadcaster: 'pusher',
  key: 'rylNoQgjY9',
  forceTLS: true,
  wsHost: 'pazhsocket.iran.liara.run',
  wsPort: 443,
  disableStats: true,
});


Vue.config.productionTip = false;
Vue.config.devtools = false;
Vue.use(VueToast,{
  duration : 5000,
  position: 'bottom-left',
})
Vue.use(VuePersianDatetimePicker, {
  name: 'date-picker',
  props: {
     
    inputFormat: 'YYYY-MM-DD',
    format: 'jYYYY-jMM-jDD',
    editable: false,
    inputClass: 'datePicker',
    placeholder: 'لطفا تاریخ را انتخاب کنید',
    altFormat: 'YYYY-MM-DD',
    autoSubmit: false,

    //...
    //... And whatever you want to set as default
    //...
  }
});
new Vue({
  store,
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
